import { render, staticRenderFns } from "./ShopTableItem.vue?vue&type=template&id=4c29b5c4&scoped=true&"
import script from "./ShopTableItem.vue?vue&type=script&lang=js&"
export * from "./ShopTableItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopTableItem.vue?vue&type=style&index=0&id=4c29b5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29b5c4",
  null
  
)

export default component.exports